import ForgotPasswordModal from './forgot-password-modal/index';
import ResetPasswordModal from './reset-password-modal/index';
import DeleteModuleModal from './delete-conformation-modal/index'
import ApproveModuleModal from './approve-conformation-modal';
import SaveModuleModal from './save-confirmation-modal';
export default {
  ForgotPasswordModal,
  ResetPasswordModal,
  DeleteModuleModal,
  ApproveModuleModal,
  SaveModuleModal
};
